import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    Icon, Checkbox, Select, Spin, Input, Col, Modal,
} from 'antd';
import lodash from 'lodash';
import { getLeadProfileRequest } from '../../redux/actions/get_lead_profile.actions';
import { firstLetterLowCase, firstLetterUpperCase, get } from '../../../../../shared/helpers';
import { changeRefBikeLeadRequest } from '../../redux/actions/change_ref_bike_lead.actions';
import { searchByBrandRequest } from '../../../../PlatformManagement/BikeManagement/redux/actions/search_by_brand.actions';
import { searchBikeModelRequest } from '../../../../PlatformManagement/BikeManagement/redux/actions/search_bike_model.actions';
import { searchBikeVariantRequest } from '../../redux/actions/search_by_variants.actions';
import { findBikeRequest } from '../../../Lead_create/redux/actions/find_bike.actions';
import { getRefBikeModelRequest } from '../../redux/actions/get_ref_bike_models.actions';
import BikeLookupModal from './components/BikeLookupModal';

const mapStateToProps = (state) => {
    const { filteredBrands, filteredModels } = state.PlatformManagement.Bike_management;
    const {
        bike_details, years, loading, part_ex,
    } = state.Leads.Lead_profile.Ref_bike_lead;
    const lead_id = state.Leads.Lead_profile.Lead_general.root_id;
    const {
        brands, models, variants, bike_info_by_vrm,
    } = state.Leads.Lead_create;
    return {
        bike_details, loading, filteredBrands, years, filteredModels, part_ex, lead_id, brands, models, variants, bike_info_by_vrm,
    };
}; const
    { Option } = Select;

export default connect(mapStateToProps, null)(class BikeDetails extends Component {
    // lead_id = this.props.lead_id || history.location.pathname.slice(-24);
    state = {
        bike_details: {},
        prevProps: this.props,
        condition: '',
        experian_name: '',
        document_history: '',
        bike_category: '',
        non_runner: '',
        model: '',
        brand: '',
        year: '',
        model_id: null,
        brand_id: null,
        year_id: null,
        isEdit: false,
        index: null,
    };

    static getDerivedStateFromProps(props, state) {
        if (props.bike_details !== state.prevProps.bike_details) {
            return {
                prevProps: props,
                bike_details: props.bike_details,
                brand: get(props.bike_details, 'ref_bike_brand.name'),
                brand_id: get(props.bike_details, 'ref_bike_brand._id'),
                model: `${get(props.bike_details, 'ref_bike_model.name') || ''} ${get(props.bike_details, 'ref_bike_model.variation') || ''}`,
                model_id: get(props.bike_details, 'ref_bike_model._id'),
                year: get(props.bike_details, 'ref_bike_variant.year'),
                year_id: get(props.bike_details, 'ref_bike_variant._id'),
                experian_name: get(props.bike_details, 'experian_name'),
                condition: get(props.bike_details, 'condition'),
                document_history: get(props.bike_details, 'document_history'),
                bike_category: get(props.bike_details, 'bike_category'),
                non_runner: get(props.bike_details, 'non_runner'),
            };
        }
        return null;
    }

    edit = (index) => this.setState({ isEdit: !this.state.isEdit, index });

    handleInputChange = (key, value) => {
        if (key === 'model_variation') {
            this.setState((prevState) => ({
                ...prevState,
                bike_details: {
                    ...prevState.bike_details,
                    ref_bike_model: {
                        ...prevState.bike_details.ref_bike_model,
                        [key]: value,
                    },
                },
            }));
        }
        if (key === 'mileage') {
            return /^[0-9\b]+$/.test(value)
                ? this.setState((prevState) => ({ ...prevState, bike_details: { ...prevState.bike_details, [key]: value } }))
                : null;
        }

        this.setState((prevState) => ({ ...prevState, bike_details: { ...prevState.bike_details, [key]: value } }));
    };

    handleSelectChange = (_id, key, value, list) => {
        if (key === 'ref_bike_variant') {
            const selected = list.filter((e) => e._id === value);
            let year = 0;

            if (selected.length > 0) {
                year = selected[0].year;
            }

            this.props.dispatch(changeRefBikeLeadRequest(_id, key, value, this.props.lead_id));

            if (year > 0) {
                this.props.dispatch(changeRefBikeLeadRequest(_id, 'unmaped_data.bike_year', year, this.props.lead_id));
            }
        } else {
            this.props.dispatch(changeRefBikeLeadRequest(_id, key, value, this.props.lead_id));
            if (key === 'ref_bike_model') {
                window.location.reload();
            }
        }


        this.setState({ isEdit: false });
    };

    save = (_id, key, value, checked) => {
        const { dispatch } = this.props;
        switch (key) {
        case 'model_variation':
            dispatch(changeRefBikeLeadRequest(this.props.bike_details.ref_bike_model._id, key, value));
            break;
        case 'ref_bike_brand':
        case 'ref_bike_variant':
        case 'ref_bike_model':
            dispatch(changeRefBikeLeadRequest(_id, key, this.state[`${firstLetterLowCase(checked)}_id`], this.props.lead_id));
            break;
        case 'panniers':
        case 'race_replica':
        case 'written_off':
        case 'has_abs':
            dispatch(changeRefBikeLeadRequest(_id, key, checked, this.props.lead_id));
            break;
        case 'condition':
        case 'document_history':
        case 'non_runner':
        case 'mileage':
        case 'bike_category':
            dispatch(changeRefBikeLeadRequest(_id, key, value, this.props.lead_id));
            break;
        default:
            dispatch(changeRefBikeLeadRequest(_id, key, value));
            break;
        }
        this.setState({ isEdit: false });
    };

    searchByValue = (value, key) => {
        const { dispatch, bike_details } = this.props;
        switch (key) {
            case 'Make':
                dispatch(searchByBrandRequest(value));
                break;
            case 'Model':
                dispatch(searchBikeModelRequest(value, (this.state.brand_id || get(bike_details, 'ref_bike_brand._id'))));
                break;
            case 'Year':
                dispatch(searchBikeVariantRequest(this.state.model_id, value));
                break;
            default: {
                return false;
            }
        }
        this.setState({ fetching: true });
    };

    findBike = lodash.debounce((bike_details, data) => {
        const { lead_id } = this.props;
        this.props.dispatch(findBikeRequest(bike_details.vrm));
    }, 500);

    render() {
        const {
            filteredBrands, years, filteredModels, loading,
        } = this.props;
        const { isEdit, bike_details } = this.state;
        const {
            vrm, ref_bike_brand, ref_bike_model, ref_bike_variant, written_off, mileage, colour, condition,
            document_history, panniers, non_runner, race_replica, has_abs, previous_owner_count, year_code, bike_category,
        } = bike_details;
        const bike_details_fields = [
            {
                label: 'VRM', value: vrm && vrm.toUpperCase(), key: 'vrm', editable: true,
            },
            {
                label: 'Make', value: get(ref_bike_brand, 'name'), key: 'ref_bike_brand', options: filteredBrands, editable: true,
            },
            {
                label: 'Model',
                get value() {
                    let value = '';
                    if (get(ref_bike_model, 'name') === 'None') {
                        value += get(bike_details.unmaped_data, 'bike_model');
                    } else if (get(ref_bike_model, 'name')) {
                        value += get(ref_bike_model, 'name');
                    } else if (get(ref_bike_model, 'variation')) {
                        value += get(ref_bike_model, 'variation');
                    } else if (get(bike_details.unmaped_data, 'bike_model')) {
                        value += get(bike_details.unmaped_data, 'bike_model');
                    } else if (get(bike_details.unmaped_data, 'bike_model_variant')) {
                        value += get(bike_details.unmaped_data, 'bike_model_variant');
                    }

                    return value;
                },
                key: 'ref_bike_model',
                options: filteredModels,
                editable: true,
            },
            {
                label: 'Year',
                options: years,
                get value() {
                    let value = '';
                    if (get(ref_bike_variant, 'year')) {
                        value += get(ref_bike_variant, 'year');
                    } else {
                        value += get(bike_details.unmaped_data, 'bike_year');
                    }
                    return value;
                },
                key: 'ref_bike_variant',
                editable: true,
            },
            {
                label: 'Variation',
                value: get(this.props.bike_details, 'model_variation') || get(ref_bike_model, 'model_variation'),
                key: 'model_variation',
                editable: false,
            },
            {
                label: 'Full Name',
                value: get(this.props.bike_details, 'experian_name'),
                key: 'experian_name',
                editable: false,
            },
            {
                label: 'Year Code', value: year_code, key: 'year_code', editable: true,
            },
            {
                label: 'Engine Size',
                value: (get(ref_bike_model, 'cc')) ? get(ref_bike_model, 'cc') : get(bike_details.unmaped_data, 'bike_cc'),
                editable: false,
            },
            {
                label: 'Colour', value: colour, key: 'colour', editable: true,
            },
            {
                label: 'Mileage', value: !/[0-9]|\./.test(mileage) ? null : mileage, key: 'mileage', editable: true,
            },
            {
                label: 'Non-Runner',
                value: non_runner,
                options: ['Yes', 'No', 'Just needs a battery', 'Not Captured'],
                key: 'non_runner',
                editable: true,
            },
            {
                label: 'Written Off', value: written_off, key: 'written_off', editable: true,
            },
            {
                label: 'Owners', value: previous_owner_count, key: 'previous_owner_count', editable: true,
            },
            {
                label: 'Service History',
                value: document_history,
                options: ['Full History', 'Part History', 'First not due', 'No History', 'Not Captured'],
                key: 'document_history',
                editable: true,
            },
            {
                label: 'Category',
                value: bike_category,
                options: ['Adventure', 'Classic', 'Commuter', 'Custom Cruiser', 'Enduro', 'Minibike', 'Moped', 'Moto Cross', 'Naked', 'Quad/ATV', 'Roadster/Retro', 'Scooter', 'Sidecar', 'Special', 'Sports Tourer', 'Super Moto', 'Super Sports', 'Supermoto-Road', 'Three Wheeler', 'Tourer', 'Trail (Enduro)', 'Trail Bike', 'Trial Bike'],
                key: 'bike_category',
                editable: true,
            },
            {
                label: 'Condition',
                value: condition,
                options: ['5 - Showroom Condition', '4 - Good', '3 - Average', '2 - Below Average', '1 - Very Poor', 'Not Captured'],
                key: 'condition',
                editable: true,
            },
            {
                label: 'Panniers', value: panniers, key: 'panniers', editable: true,
            },
            {
                label: 'Race Replica', value: race_replica, key: 'race_replica', editable: true,
            },
            {
                label: 'Has ABS', value: has_abs, key: 'has_abs', editable: true,
            },
        ];

        return (
            <Col span={24}>
                <Spin size="small" spinning={loading} tip="Bike Details updating ...">
                    <h3 className="header">Bike Details</h3>
                    {bike_details_fields.map((field, index) => (
                        <p key={index}>
                            <span style={{ width: '32%' }}>
                                {field.label}
                                :
                            </span>
                            {isEdit && this.state.index === index
                                ? (
                                    <Fragment>
                                        {(field.label === 'Make'
                                    || field.label === 'Model'
                                    || field.label === 'Year')
                                            ? (
                                                <Select
                                                    size="small"
                                                    showSearch
                                                    filterOption={false}
                                                    placeholder={`Search by ${firstLetterLowCase(field.label)}`}
                                                    notFoundContent="No Found"
                                                    style={{ width: '60%', fontWeight: '400', fontSize: '12px' }}
                                                    value={this.state[firstLetterLowCase(field.label)]}
                                                    onSearch={(value) => this.searchByValue(value, field.label)}
                                                    onChange={(value) => this.handleSelectChange(bike_details._id, field.key, value, field.options)}
                                                >
                                                    {field.options && field.options.map((item) => (field.label === 'Year'
                                                        ? <Option value={item._id} key={item._id} year={item.year}>{item.year}</Option>
                                                        : (
                                                            <Option style={{ fontSize: 11 }} value={item._id} key={item._id} year={item.year}>
                                                                {item.name}
                                                                {' '}
                                                                {firstLetterUpperCase(item.model_variation || '')}
                                                            </Option>
                                                        )))}
                                                </Select>
                                            )
                                            : field.options
                                                ? (
                                                    <Select
                                                        size="small"
                                                        defaultValue={field.value}
                                                        style={{ width: '60%', fontWeight: '400', fontSize: '12px' }}
                                                        onChange={(value) => this.save(bike_details._id, field.key, value, field.label)}
                                                    >
                                                        {field.options.map((value) => <Option key={value.key} value={value}>{value}</Option>)}
                                                    </Select>
                                                )
                                                : (
                                                    <Input
                                                        size="small"
                                                        style={{ width: '30%' }}
                                                        type="text"
                                                        value={field.value}
                                                        onPressEnter={() => this.save(bike_details._id, field.key, field.value, field.label)}
                                                        onChange={(event) => this.handleInputChange(field.key, event.target.value)}
                                                    />
                                                )}
                                        {field.label === 'VRM'
                                            ? <Icon type="search" style={{ marginLeft: '5px' }} onClick={() => this.findBike(bike_details, field)} />
                                            : <Icon type="save" style={{ marginLeft: '5px' }} onClick={() => this.save(bike_details._id, field.key, field.value, field.label)} />}
                                    </Fragment>
                                )
                                : (
                                    <Fragment>
                                        {!/Written Off|Race Replica|Has ABS|Panniers/.test(field.label)
                                            ? (
                                                <span className="value">
                                                    {(field.label === 'Condition')
                                                        ? this.state[field.key]
                                                        : (field.value === 0 || !field.value) ? 'None' : field.value}
                                                    {field.editable
                                                        ? <Icon type="edit" style={{ marginLeft: '5px' }} onClick={() => this.edit(index)} /> : null}
                                                </span>
                                            )
                                            : (
                                                <Fragment>
                                                    <Checkbox
                                                        style={{ width: '10%', marginLeft: '5px' }}
                                                        checked={field.value}
                                                        onChange={(event) => this.save(bike_details._id, field.key, field.value, event.target.checked)}
                                                    />
                                                </Fragment>
                                            )}
                                    </Fragment>
                                )}
                        </p>
                    ))}
                    {this.props.part_ex && this.props.part_ex.ref_bike_inventory
                && (
                    <Fragment>
                        <h3 className="header" style={{ marginTop: '10px' }}>Part Exchange Bike</h3>
                        <p className="bike_details long">
                            <span style={{ width: '16%' }}>Bike:</span>
                            <span className="value">
                                <a
                                    href={this.props.part_ex?.ref_bike_inventory?.superbike_factory_url
                                        || 'http://www.superbikefactory.co.uk'}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    £
                                    {this.props.part_ex.ref_bike_inventory?.price?.retail_price || ''}
                                    {' '}
                                    &bull;
                                    {this.props.part_ex.ref_bike_inventory?.vrm || ''}
                                    {' '}
                                    &bull;
                                    &nbsp;
                                    {this.props.part_ex.ref_bike_inventory?.ref_bike_brand?.name || ''}
                                    &nbsp;
                                    {this.props.part_ex.ref_bike_inventory?.ref_bike_model?.name || ''}
                                </a>
                            </span>
                        </p>
                    </Fragment>
                )}
                    <BikeLookupModal handleChangeEditMode={() => this.edit(this.state.index)} />
                </Spin>
            </Col>
        );
    }
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_table/BikeDetails.js